import get from 'get-object-path';
import store from '@/store';

export function hasGivenPermission(permissionId) {
    const permissions = get(store.getters.selectedClub, 'permissions.data') || [];
    return !!permissions.find(permission => get(permission, 'permission.data.id') === permissionId);
}
